export const candidates = [
  {
    name: {
      en: "Macao Occupational Skills Recognition System (MORS)",
      zh: "澳門職業技能認可基準（MORS）",
    },
    count: 1742,
  },
  {
    name: {
      en: "Language Examinations for Tour Guides",
      zh: "導遊：語言考試",
    },
    count: 39,
  },
]

export const sumOfCandidates = candidates.reduce((sum, candidate) => (sum + candidate.count), 0)
